import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { recoveryCodeVerification } from '../../../services/auth';

interface IProps {
  code: string;
}

export const ThunkRecoveryCodeVerification = createAsyncThunk<{ userName: string }, IProps>(
  `${storeResources.AUTH}/recoveryCodeVerification`,
  ({ code }: IProps) => recoveryCodeVerification(code).then(res => res.data),
);

export default {};
